// extracted by mini-css-extract-plugin
export default {"back":"RegisterOthers_back__x70br","form":"RegisterOthers_form__31b88","validator":"RegisterOthers_validator__dFI4b","formButton":"RegisterOthers_formButton__vvbJq"};